module.exports = "images/teamed_image_07.png";